import React from "react";

import * as classes from "./ContentSelector.module.css";

export default function (props) {
  const {display, setDisplay} = props;

  const onClickHandler = (e) => {
    console.log(e.target.name);
    if (e.target.name === "webcam") {
      setDisplay("webcam");
    } else if (e.target.name === "game") {
      setDisplay("game");
    }
  };

  return (
    <div className={classes.Tab}>
      <button
        className={display === "webcam" ? classes.Active : null}
        name="webcam"
        onClick={onClickHandler}
      >
        Webcam Sudoku Solver
      </button>
      <button
        className={display === "game" ? classes.Active : null}
        name="game"
        onClick={onClickHandler}
      >
        Visualize Solver Algorithm
      </button>
    </div>
  );
}
